import { APIClient } from "./api_helper";

import * as url from "./url_helper";

import getConfig from "../config/config";

const config = getConfig();

const { company } = config;
const company_id = company.COMPANY_ID;

const api = new APIClient();

// Gets the logged in user data from local session
export const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

// is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Sales Register
export const postSalesRegisterFormData = (data: FormData) =>
  api.createFormData(url.SALES_REGISTER, data);

// Invest Register
export const postInvestRegisterFormData = (data: FormData) =>
  api.create(url.INVEST_REGISTER, data);

// Login Method
export const postFakeLogin = (params: any) =>
  api.create(
    url.POST_LOGIN +
      `?username=${params.email}&password=${params.password}&companyId=${company_id}`,
    "",
  );

// GET AUTH DATA
export const getAuthList = () => api.get(url.GET_AUTH_DATA, "");

// POST FORGOT_PASSWORD
export const forgotPassword = (data: any) =>
  api.create(
    `${url.FORGOT_PASSWORD}?email=${data.email}&company_id=${company_id}`,
    "",
  );

// POST FORGOT_PASSWORD_NEW_PASS
export const forgotPasswordNewPass = (data: any) =>
  api.create(
    `${url.FORGOT_PASSWORD_NEW_PASS}/${data.passwordChangeGuid}`,
    data,
  );

export const postDecodeEncryptLogin = (data: any) =>
  api.create(url.POST_DECODE_ENCRYPT_LOGIN, data);

// postForgetPwd
export const postFakeForgetPwd = (data: any) =>
  api.create(url.POST_FAKE_PASSWORD_FORGET, data);

// Edit profile
export const postJwtProfile = (data: any) =>
  api.create(url.POST_EDIT_JWT_PROFILE, data);

export const postFakeProfile = (data: any) =>
  api.update(url.POST_EDIT_PROFILE + "/" + data.idx, data);

// Register Method
export const postJwtRegister = (url: string, data: any) => {
  return api.create(url, data).catch((err) => {
    var message;
    if (err.response && err.response.status) {
      switch (err.response.status) {
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        case 401:
          message = "Invalid credentials";
          break;
        default:
          message = err[1];
          break;
      }
    }
    throw message;
  });
};

// Login Method
export const postJwtLogin = (data: any) =>
  api.create(url.POST_FAKE_JWT_LOGIN, data);

// postForgetPwd
export const postJwtForgetPwd = (data: any) =>
  api.create(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

// GET TRANSLATION
export const getTranslations = (languageCode: any) =>
  api.create(url.GET_TRANSLATION + `${languageCode}`, "");

// CHECK EMAIL EXIST
export const checkEmailExist = (email: string) =>
  api.get(url.GET_CHECK_EMAIL_EXIST + `?email=${email}`, "");

// get Task
export const getTaskList = () => api.get(url.GET_TASK_LIST, "");
export const addNewTask = (task: any) => api.create(url.ADD_NEW_TASK, task);
export const updateTask = (task: any) => api.update(url.UPDATE_TASK, task);
export const deleteTask = (task: any) =>
  api.delete(url.DELETE_TASK, { headers: { task } });

// Kanban Board
export const getTasks = () => api.get(url.GET_TASKS, "");
export const addNewTasks = (card: any) => api.create(url.ADD_TASKS, card);
export const updateTasks = (card: any) => api.put(url.UPDATE_TASKS, card);
export const deleteTasks = (card: any) =>
  api.delete(url.DELETE_TASKS, { headers: { card } });

// GET COUNTRY LIST
export const getCountryList = () => api.get(url.GET_COUNTRY_LIST, "");
export const getCountryListInt2 = () => api.get(url.GET_COUNTRY_LIST_INT2, "");

//! PARTNER
// GET DOCUMENT TYPE LIST
export const getDocumentTypeList = () =>
  api.get(url.GET_DOCUMENT_TYPE_LIST, "");

// SUMMARY CARDS
export const getSummaryCards = (id: number) =>
  api.get(url.PARTNER_QUERY + `${id}` + url.GET_SUMMARY_CARD_INFO, "");

// REFERRAL LINK DETAIL
export const getReferralLinkDetails = (id: number) =>
  api.get(url.PARTNER_QUERY + `${id}` + url.GET_REFERAL_LINK_INFO, "");

// CONTRACTS TO PARTNER
export const getContractsToPartner = (id: any) =>
  api.get(`${id}` + url.GET_CONTRACTS_TO_PARTNER, "");

// ADD REFERRAL LINK DETAILS
export const addReferralLinkDetailsForLanguage = (id: number, data: any) =>
  api.create(url.PARTNER_QUERY + `${id}` + url.ADD_REFERRAL_LINK_DETAILS, data);

// REBATE DETAIL
export const getRebateDetails = (id: number) =>
  api.get(url.PARTNER_QUERY + `${id}` + url.GET_REBATE_DETAILS, "");

// IB ONBOARDING PERSONAL INFO
export const addIBOnboardingPersonalInfo = (data: any) =>
  api.create(url.IB_ONBOARDING_PERSONAL_INFO, data);

// INVEST IB ONBOARDING SMS VERIFICATION SMS REQUEST
export const addInvestIBOnboardingSMSReq = (data: any) =>
  api.create(
    url.INVEST_IB_ONBOARDING_SMS_REQ + `?phoneNumber=${data.phone}`,
    "",
  );

// INVEST IB ONBOARDING SMS VERIFICATION CODE SEND
export const addInvestIBOnboardingCodeReq = (id: number, data: any) =>
  api.create(
    url.PARTNER_QUERY.toLowerCase() +
      `${id}` +
      url.INVEST_IB_ONBOARDING_CODE_SEND,
    data,
  );

// IB ONBOARDING BANK INFO
export const addIBOnboardingBankInfo = (id: number, data: FormData) =>
  api.createFormData(
    url.PARTNER_QUERY + `${id}` + url.IB_ONBOARDING_BANK_INFO,
    data,
  );

// UPDATE PERSONAL PASSWORD
export const changePersonalPassword = (data: any) =>
  api.create(url.CHANGE_PERSONAL_PASSWORD, data);

// IB ONBOARDING IDENTITY VERIFICATION
export const addIBOnboardingIdentityVerify = (id: number, data: FormData) =>
  api.createFormData(
    url.PARTNER_QUERY + `${id}` + url.IB_ONBOARDING_IDENTITY_VERIFICATION,
    data,
  );

// IB ONBOARDING ADDRESS VERIFICATION
export const addIBOnboardingAddressVerify = (id: number, data: any) =>
  api.createFormData(
    url.PARTNER_QUERY + `${id}` + url.IB_ONBOARDING_ADDRESS_VERIFICATION,
    data,
  );

//  PARTNER CLIENTS (DASHBOARD GRAPHİC)
export const getPartnerClients = (id: number) =>
  api.get(
    url.PARTNER_QUERY.toLowerCase() +
      `${id}` +
      url.GET_PARTNER_CLIENTS_GRAPHIC_INFO,
    "",
  );

// DASHBOARD GRAPHİC PARTNER TRADING VOLUME
export const getPartnerTradingVolume = (id: number) =>
  api.get(
    url.PARTNER_QUERY + `${id}` + url.GET_PARTNER_TRADING_VOLUME_GRAPHIC_INFO,
    "",
  );

// DASHBOARD GRAPHİC PARTNER TRADING VOLUME
export const getPartnerBalance = (id: number) =>
  api.get(
    url.PARTNER_QUERY + `${id}` + url.GET_PARTNER_BALANCE_GRAPHIC_INFO,
    "",
  );

//  GET USER ADDRESS INFOS
export const getUserAddressInfos = () =>
  api.get(url.GET_USER_ADDRESS_INFOS, "");

// PNL SHARE CONTRACT INFO
export const getPNLShareContractInfo = (id: number) =>
  api.get(url.PNL_SHARE_CONTRACT_INFO + `${id}`, "");

// Reports Open Positions
export const getOpenPositions = (id: number, data: any) =>
  api.create(
    url.PARTNER_QUERY.toLowerCase() + `${id}` + url.GET_REPORTS_OPEN_POSITIONS,
    data,
  );

// Reports Client List
export const getClientList = (id: number, data: any) =>
  api.create(
    url.PARTNER_QUERY.toLowerCase() + `${id}` + url.GET_PARTNER_CLIENTS,
    data,
  );

// Reports Closed Trades
export const getClosedTrades = (id: number, data: any) =>
  api.create(
    url.PARTNER_QUERY.toLowerCase() + `${id}` + url.GET_CLOSED_POSITIONS,
    data,
  );

// Reports Deals
export const getDeals = (id: number, data: any) =>
  api.create(url.PARTNER_QUERY + `${id}` + url.GET_DEALS, data);

// Reports Equity Report
export const getEquityReport = (id: number, data: any) =>
  api.create(
    url.PARTNER_QUERY.toLowerCase() + `${id}` + url.GET_EQUITY_REPORTS,
    data,
  );

// Reports Money Transfer Report
export const getMoneyTransferReport = (id: number, data: any) =>
  api.create(
    url.PARTNER_QUERY.toLowerCase() + `${id}` + url.GET_MONEY_TRANSFERS,
    data,
  );

// Reports Sub Ib List
export const getSubIbList = (id: number, data: any) =>
  api.create(url.PARTNER_QUERY.toLowerCase() + `${id}` + url.GET_SUB_IBS, data);

// Reports Top Client Reports
export const getTopClientReport = (id: number, data: any) =>
  api.create(
    url.PARTNER_QUERY.toLowerCase() + `${id}` + url.GET_TOP_CLIENTS,
    data,
  );

// Reports Top Client Reports
export const getAllInstrumentGroups = () =>
  api.get(url.GET_INSTRUMENT_GROUPS, "");

// CONTRACTS
export const getPagedContracts = (id: number, data: any) =>
  api.create(
    url.PARTNER_QUERY.toLowerCase() + `${id}` + url.GET_PAGED_CONTRACTS,
    data,
  );

// CREATE OWN CONTRACTS
export const addOwnContracts = (id: number, data: any) =>
  api.create(url.ADD_OWN_CONTRACTS + `${id}`, data);

// OWN CONTRACT REVIEW
export const getOwnContractReview = (id: number) =>
  api.get(url.GET_OWN_CONTRACT_REVIEW + `${id}`, "");

// CONTRACTS DETAIL
export const getContractDetail = (data: any) =>
  api.create(url.GET_PAGED_CONTRACT_ACCOUNT, data);

// CONTRACTS STANDART RATES
export const getContractsStandartRates = (id: number, data: any) =>
  api.get(url.GET_STANDART_RATES + `${id}`, data);

// OLD CONTRACT RATES
export const getOldContractsRates = (id: number) =>
  api.get(url.GET_OLD_CONTRACT_RATES + `${id}`, "");

// GET SCA ACCOUNT INFO LIST>
export const getScaAccountInfoList = () =>
  api.get(url.GET_SCA_ACCOUNT_INFO_LIST, "");

// GET WALLET ACCOUNT INFO LIST>
export const getWalletAccountInfoList = (id: number) =>
  api.get(url.GET_WALLET_ACCOUNT_INFO_LIST + `${id}`, "");

// GET SCA DATE OF BIRTH INFO
export const getDateOfBirthInfo = (id: number) =>
  api.get(url.PARTNER_QUERY + `${id}` + url.GET_USER_DATE_OF_BIRTH_INFO, "");

// WITHDRAWAL POST INFO
export const addWithdrawalInfo = (data: any) =>
  api.create(url.ADD_WITHDRAWAL_INFO, data);

// WITHDRAWAL WALLET INFO POST
export const addWithdrawalWalletInfo = (data: any) =>
  api.create(url.ADD_WITHDRAWAL_WALLET_INFO, data);

// WITHDRAWAL POST INFO
export const addInternalTransferInfo = (data: any) =>
  api.create(url.ADD_INTERNAL_TRANSFER_INFO, data);

// GET DEPOSIT REDIRECT PARAMETER
export const getDepositRedirectParameter = () =>
  api.get(url.GET_DEPOSIT_REDIRECT_PARAMETER, "");

// Get REBATES
export const getRebates = (id: number, data: any) =>
  api.create(url.PARTNER_QUERY.toLowerCase() + `${id}` + url.GET_REBATES, data);

export const getRebatesPNL = (id: number, data: any) =>
  api.create(
    url.PARTNER_QUERY.toLowerCase() + `${id}` + url.GET_REBATES_PNL,
    data,
  );

// PAYMENT HISTORY
export const getPagedPaymentHistoryReport = (id: number, data: any) =>
  api.create(
    url.PARTNER_QUERY + `${id}` + url.GET_PAGED_PAYMENT_HISTORY_REPORT,
    data,
  );

// GET OFFICES INFO
export const getOfficesInfo = () => api.get(url.GET_OFFICES_INFO, "");

//! SALES

// SALES REGISTER
export const postSalesRegister = (data: any) =>
  api.create(url.SALES_REGISTER, data);

// SALES SUMMARY CARDS
export const getSalesSummaryCards = (id: number, data: any) =>
  api.create(url.GET_SALES_SUMMARY_CARD_INFO + `${id}`, data);

// SALES GET REFERRAL LINK DETAILS INFO
export const getSalesReferralLinkDetails = (id: number) =>
  api.get(url.GET_SALES_REFERRAL_LINK_DETAILS_INFO + `${id}`, "");

// DASHBOARD GRAPHİC PARTNER TRADING VOLUME
export const getSalesNetworkChart = (id: number, data: any) =>
  api.create(url.GET_SALES_NETWORK_GRAPHIC_INFO + `${id}`, data);

// SALES ADD REFERRAL LINK DETAILS
export const addSalesReferralLinkDetailsForLanguage = (id: number, data: any) =>
  api.create(url.ADD_SALES_REFERRAL_LINK_DETAILS + `${id}`, data);

// GET SALES REBATE DETAILS
export const getSalesRebateDetails = (id: number) =>
  api.get(url.SELLER_QUERY + `${id}` + url.GET_SALES_REBATE_DETAILS, "");

// SALES GET REPORTS PARTNER LIST
export const getSalesPartnerList = (id: number, data: any) =>
  api.create(url.GET_SALES_REPORTS_PARTNER_LIST + `${id}`, data);

// SALES GET REPORTS RETAIL LIST
export const getSalesClientList = (id: number, data: any) =>
  api.create(url.GET_SALES_REPORTS_CLIENT_LIST + `${id}`, data);

// SALES GET REPORTS NETWORK LIST
export const getSalesNetworkList = (id: number, data: any) =>
  api.create(url.GET_SALES_REPORTS_NETWORK_LIST + `${id}`, data);

// SALES GET REPORTS NETWORK LIST
export const getSalesMoneyTransferList = (id: number, data: any) =>
  api.create(url.GET_SALES_REPORTS_MONEY_TRANSFER_LIST + `${id}`, data);

// SALES GET REPORTS EQUITY
export const getSalesEquityReport = (id: number, data: any) =>
  api.create(url.GET_SALES_REPORTS_EQUITY + `${id}`, data);

// SALES GET CONTRACTS DETAIL
export const getSalesContractDetail = (data: any) =>
  api.create(url.GET_SALES_PAGED_CONTRACT_ACCOUNT_DETAIL, data);

// SALES REBATE / COMMISSION
export const getSalesCommission = (id: number, data: any) =>
  api.create(
    url.SELLER_QUERY + `${id}` + url.GET_SALES_PAGED_COMMISSINON_DETAIL,
    data,
  );

// PAYMENT HISTORY
export const getSalesPaymentHistoryReport = (id: number, data: any) =>
  api.create(url.GET_SALES_PAGED_PAYMENT_HISTORY_REPORT + `${id}`, data);
